import { uniqBy } from 'lodash';
import { useSelector } from 'react-redux';

import {
  useGetUnitRosterAdultsQuery,
  useGetUnitRosterParentsQuery,
  useGetUnitRosterYouthsQuery,
} from '@modules/roster/api';
import { organizationGuidSel } from '@shared/duck/selectors/general.selectors';

export function useUnitRoster() {
  const organizationGuid = useSelector(organizationGuidSel);
  const {
    isFetching: loadingRosterAdults,
    data: rosterAdults = { users: [] },
  } = useGetUnitRosterAdultsQuery(
    {
      organizationGuid,
    },
    {
      skip: !organizationGuid,
    },
  );

  const {
    isFetching: loadingRosterYouths,
    data: rosterYouths = { users: [] },
  } = useGetUnitRosterYouthsQuery(
    {
      organizationGuid,
    },
    {
      skip: !organizationGuid,
    },
  );

  const { isFetching: loadingRosterParents, data: rosterParents = [] } =
    useGetUnitRosterParentsQuery(
      {
        organizationGuid,
      },
      {
        skip: !organizationGuid,
      },
    );

  return {
    leaders: rosterAdults.users,
    parents: uniqBy(rosterParents, 'parentUserId'),
    youths: rosterYouths.users,
    isRosterLoading:
      loadingRosterAdults || loadingRosterYouths || loadingRosterParents,
  };
}
